import React, { forwardRef, InputHTMLAttributes, useId } from 'react'

import {
  FieldContainer,
  FieldLabel,
  FieldMessage,
} from '@components/formField/formField.styled'

import { InputFieldControl } from './inputField.styled'

export type InputFieldProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'size'
> & {
  label: string
  error?: string
  hint?: string
}

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  (
    { className, error, hint, id: providedId, label, required, ...inputProps },
    ref
  ) => {
    const generatedId = useId()
    const id = providedId ?? generatedId
    const message = error ?? hint
    const messageId = message ? `${id}-message` : undefined

    return (
      <FieldContainer className={className}>
        <FieldLabel htmlFor={id}>
          {label}
          {required ? ' *' : ''}
        </FieldLabel>
        <InputFieldControl
          {...inputProps}
          ref={ref}
          id={id}
          required={required}
          $invalid={Boolean(error)}
          aria-invalid={Boolean(error)}
          aria-describedby={messageId}
        />
        {message && (
          <FieldMessage
            id={messageId}
            $invalid={Boolean(error)}
            role={error ? 'alert' : undefined}
          >
            {message}
          </FieldMessage>
        )}
      </FieldContainer>
    )
  }
)

InputField.displayName = 'InputField'
